import React from "react";
import WhatsNew from "./WhatsNew";
import CaseManagementHome from "./CaseManagementHome/CaseManagementHome";
import UsefulLinks from "./CaseManagementHome/UsefulLinks";
import HomeBanner from "./HomeBanner";

const Home = ({ benchId }) => {
  return (
    <>
      <div className="col-12 col-sm-12 col-md-12 col-lg-6">
        <HomeBanner benchId={benchId} />
        {/* <WhatsNew benchId={benchId} /> */}
        <CaseManagementHome benchId={benchId} />
      </div>
      <UsefulLinks />
    </>
  );
};

export default Home;
